import { createContext, useContext } from 'react'

export const FlagsContext = createContext<Record<string, boolean | string>>({})
export default function useFlags() {
  return useContext(FlagsContext)
}
